// extracted by mini-css-extract-plugin
module.exports = {"root":"ACTtD","header":"uYo77","footer":"x9t6P","title":"_2Zen1","tilesArea":"ZhQw5","tile":"_2HvLU","tileIconArea":"_24Mny","tileIcon":"_3Jurj","tileDescription":"_17DNQ"};